module.exports = __webpack_public_path__ + "img/image_7.e31a6d97.jpg";